import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
// import { Observable } from 'rxjs';
import { Router } from "@angular/router";

@Injectable({
  providedIn: 'root'
})
export class AuthGuardService implements CanActivate {

  constructor(private router: Router) { }

  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): boolean {
      if (!localStorage.getItem('uid')) {
        localStorage.removeItem('uid');
        // this.router.navigateByUrl('/login');
        this.router.navigate(['login'], { queryParams: { returnUrl: state.url }});
        return false;
      }
      return true;
  }
}
